export default __webpack_public_path__ + "static/SRUS 1027PW - Product Specifications & Technical Data-2e1c865509768738bf64b8433bdfb6af.pdf";